import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonDimensions } from 'src/app/models/collection.interface';
import { CommonModule } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-row-dialog',
  standalone: true,
  imports: [
    MatButtonModule,
    CommonModule,
    MatDividerModule,
    MatIconModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule
  ],
  templateUrl: './row-dialog.component.html',
  styleUrl: './row-dialog.component.scss'
})
export class RowDialogComponent {
  documentTitle: string;
  // Dimensions passed in from the parent component
  filteredDimensions: CommonDimensions;
  // Values to be edited
  editableValues: Partial<CommonDimensions> = {};
  // Dimensions to exclude
  excludedDimensions = ['original_document_uri', 'collection_id', 's3_output_path', 'collection_name', 'file_id'];
  dimensions: CommonDimensions = this.data.dimensions;
  adminMode: boolean = this.data.adminMode;

  constructor(
    public dialogRef: MatDialogRef<RowDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { dimensions: CommonDimensions; adminMode: boolean }
  ) {
    this.documentTitle = this.getDocumentTitle(data.dimensions['original_document_uri']);
    this.filteredDimensions = this.filterDimensions(this.excludedDimensions);
    this.editableValues = { ...this.filteredDimensions };
  }

  getDocumentTitle(path: string): string {
    if (!path) return '';

    const normalizedPath = path.replace(/\\/g, '/');
    const parts = normalizedPath.split('/');
    return parts[parts.length - 1] || '';
  }

  filterDimensions(excludedDimensions: string[]): CommonDimensions {
    const result = {} as CommonDimensions;
    for (const [key, value] of Object.entries(this.dimensions)) {
      if (!excludedDimensions.includes(key.toLowerCase())) {
        result[key] = value;
      }
    }
    return result;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  onSave() {
    // Return the edited values to the parent component
    this.dialogRef.close({
      action: 'save',
      data: this.editableValues
    });
  }

  onCancel() {
    this.dialogRef.close({
      action: 'cancel'
    });
  }
}
